import request from '@/utils/request'

/**
 * 公共上传文件接口
 * @param {*} file 文件
 * @returns 
 */
export function uploadFile(file) {
  let formData = new FormData()
  formData.append('file', file, file?.name || 'file')

  return request({
    url: '/file/upload',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}
